import { FontWeight } from '@pasteltech/theme-provider'
import { memo } from 'react'
import styled from 'styled-components'
import { getCasePostedAtString } from '../../helper'
import {
  CaseCardBottomLeftDecoratorIcon,
  CaseCardTopRightDecoratorIcon,
} from '../../svg-components'
import { DeepNullable } from '../../utilities'
import { StrapiImage, StrapiImageData } from '../strapi-image'
import { StrapiVideoData } from '../strapi-video'

const CaseContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  background: ${({ theme }) => theme.colors.container.lowest};
  border-radius: ${({ theme }) => theme.sizes.borderRadius.xs}px;
  box-shadow: 0 1px 2px 0 rgba(68, 70, 79, 0.2);
`
const ImageContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  border-radius: ${({ theme }) => theme.sizes.borderRadius.xs}px;
  background: ${({ theme }) => theme.colors.container.lowest};
  padding: ${({ theme }) => theme.sizes.spacings.sm}px;
  height: 300px;
`
const CaseBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 15px;
  align-self: stretch;
  border-radius: ${({ theme }) => theme.sizes.borderRadius.xs}px;
  background: ${({ theme }) => theme.colors.container.lowest};
  padding: ${({ theme }) =>
    `${theme.sizes.spacings.xl}px ${theme.sizes.spacings.lg}px`};
`
const CaseTitle = styled.div`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  align-self: stretch;
  overflow: hidden;
  color: ${({ theme }) => theme.colors.text.high};
  text-overflow: ellipsis;
  font-size: ${({ theme }) => theme.sizes.fontSize.heading3}px;
  font-weight: ${FontWeight.bold};
`
const CaseDate = styled.div`
  align-self: stretch;
  color: ${({ theme }) => theme.colors.text.medium};
  font-size: ${({ theme }) => theme.sizes.fontSize.label}px;
  font-weight: ${FontWeight.regular};
`
const StyledImageTopRightDecoratorIcon = styled(CaseCardTopRightDecoratorIcon)`
  position: absolute;
  z-index: 1;

  // must same as padding of ImageContainer
  top: ${({ theme }) => theme.sizes.spacings.sm}px;
  right: ${({ theme }) => theme.sizes.spacings.sm}px;
`
const StyledImageBottomLeftDecoratorIcon = styled(
  CaseCardBottomLeftDecoratorIcon,
)`
  position: absolute;
  z-index: 1;
  // must same as padding of ImageContainer
  bottom: ${({ theme }) => theme.sizes.spacings.sm}px;
  left: ${({ theme }) => theme.sizes.spacings.sm}px;
`
const StyledStrapiImage = styled(StrapiImage)`
  object-fit: contain;
  width: 100%;
  height: 100%;
  border-radius: ${({ theme }) => theme.sizes.borderRadius.xs}px;
`
export type Case = DeepNullable<{
  id: string
  title: string
  content: string
  images: StrapiImageData[]
  videos: StrapiVideoData[]
}> & {
  postedAt: Date | null
}

type Props = {
  post: Omit<Case, 'content'>
  onClick?: () => void
}
export const CaseCard = memo(({ post, onClick }: Props) => {
  return (
    <CaseContainer onClick={onClick}>
      <ImageContainer>
        <StyledImageTopRightDecoratorIcon />
        <StyledImageBottomLeftDecoratorIcon />
        <StyledStrapiImage strapiImage={post?.images?.[0]} />
      </ImageContainer>
      <CaseBody>
        <CaseDate>{getCasePostedAtString(post?.postedAt)}</CaseDate>
        <CaseTitle>{post?.title}</CaseTitle>
      </CaseBody>
    </CaseContainer>
  )
})
CaseCard.displayName = 'CaseCard'
